<template>
  <div class="wrapper perfect-theme-design">
    <div class="content">
      <div class="title">
        <div>
          {{ componentName }}
        </div>
        <div v-if="!isDetailPage">
          <el-button
            type="primary"
            plain
            v-if="employeeLevel > 50"
            @click="handleAddRow()"
            >新增</el-button
          >
          <el-button type="warning" plain @click="handleReset()"
            >重置</el-button
          >
        </div>
      </div>
    </div>

    <div v-if="mixinDisplayList.length">
      <div class="info">
        <el-row
          class="header"
          type="flex"
          align="middle"
          justify="center"
          style="margin-bottom:20px;"
        >
          <el-col :span="4">
            组合陈列套餐名称
          </el-col>
          <el-col :span="employeeLevel > 50 ? 6 : 8">
            堆箱信息
          </el-col>
          <el-col :span="employeeLevel > 50 ? 4 : 8">
            产品信息
          </el-col>
          <el-col :span="6" v-if="employeeLevel > 50">
            开放区域
          </el-col>
          <el-col :span="4">操作</el-col>
        </el-row>

        <el-row
          v-for="(item, index) in mixinDisplayListPagination"
          :key="index"
          class="detail"
          type="flex"
          align="middle"
          justify="center"
        >
          <!-- 组合陈列套餐名称 -->
          <el-col :span="4">
            <el-tooltip
              effect="light"
              :content="item.defineName"
              placement="top"
              :disabled="employeeLevel > 50"
            >
              <el-input
                v-model="item.defineName"
                clearable
                filterable
                placeholder="组合陈列套餐名称"
                :disabled="employeeLevel <= 50 || isDetailPage"
                @blur="checkName"
              />
            </el-tooltip>
          </el-col>

          <!-- 堆箱信息 -->
          <el-col :span="employeeLevel > 50 ? 6 : 8">
            <div v-if="item.stackPackSize">
              <!-- 单品牌堆箱 -->
              <div v-if="item.stackType === '01'">
                <div class="stack-design-title">
                  {{
                    `${item.brandName || item.subBrandInfo.abiBrandDesc}-
                    ${item.subBrandName || item.subBrandInfo.parentBrandName}-
                    ${item.stackPackSize}`
                  }}
                </div>
              </div>
              <!-- 混堆 -->
              <div v-if="item.stackType === '02'">
                <div class="stack-design-title">{{`混堆-${item.stackPackSize}`}}</div>
                <div
                  class="design-thumbnail"
                  title="查看详情"
                  @click="viewDesignDetail(index)"
                >
                  <div
                    class="design-thumbnail-column"
                    v-for="(cItem, cIndex) in item.brandList"
                    :key="cIndex"
                  >
                    <div
                      class="design-thumbnail-row"
                      v-for="(rItem, rIndex) in getLine('row', getIndex(index))"
                      :key="rIndex"
                      :style="`background:${cItem.tradeStackColor}`"
                    ></div>
                  </div>
                </div>
              </div>
              <div
                class="stack-design-modify"
                @click="modifyStackInfo(getIndex(index))"
                v-if="employeeLevel > 50 && item.canUpdate"
              >
                修改
              </div>
            </div>
            <el-button
              v-else-if="employeeLevel > 50 && !isDetailPage"
              type="success"
              plain
              @click="showStackInfoDialog(getIndex(index))"
            >
              添加
            </el-button>
          </el-col>

          <!-- 产品信息 -->
          <el-col :span="employeeLevel > 50 ? 4 : 8">
            <div
              v-for="(product, index) in item.tradePerfectScopeDetailList"
              :key="index"
            >
              <div
                v-if="product.brandCode"
                class="product-info"
              >
                {{
                  `${product.brandName}-
                  ${product.subBrandName}-
                  ${product.volume}-
                  ${product.multiPackSpec}-
                  ${product.minDisplayQty}件-
                  ${product.rowQty}面`
                }}
              </div>
            </div>
            <div
              v-if="
                item.tradePerfectScopeDetailList &&
                item.tradePerfectScopeDetailList[0].brandCode &&
                employeeLevel > 50 &&
                item.canUpdate
              "
              class="stack-design-modify"
              @click="modifyProductInfo(getIndex(index))"
            >
              修改
            </div>
            <el-button
              v-else-if="employeeLevel > 50 && !isDetailPage && item.canUpdate"
              type="success"
              plain
              @click="showProductInfoDialog(getIndex(index))"
            >添加</el-button>
          </el-col>

          <!-- 选择区域 -->
          <el-col class="region-wrapper" :span="6" v-if="employeeLevel > 50">
            <div style="margin-bottom: 10px">
              <el-checkbox-button v-model="item.checkAll" @change="handleCheckAllChange($event, item)">
                {{ item.checkAll ? "取消全选" : "全选" }}
              </el-checkbox-button>
            </div>
            <el-checkbox-group v-model="item.regionList" @change="handleRegionChange($event, item)">
              <el-checkbox-button
                v-for="item in regionListByBu"
                :label="item.orgCode"
                :key="item.orgId"
                :disabled="!item.canUpdate && $route.query.class === 'detail'"
              >
                {{ item.orgName.split('|')[0] }}
              </el-checkbox-button>
            </el-checkbox-group>
          </el-col>

          <el-col :span="4" v-if="employeeLevel > 50">
            <!-- <el-button :disabled="$route.query.class === 'detail'" v-if="getIndex(index) === 0" type="primary" plain @click="handleAddRow(index)">新增</el-button> -->
            <el-button
              :disabled="$route.query.class === 'detail'"
              type="danger"
              plain
              @click="handleDeleteRow(getIndex(index))"
              >删除</el-button
            >
          </el-col>

          <el-col :span="4" v-else>
            <!-- <el-checkbox :disabled="$route.query.class === 'detail'" v-model="checkedIndexList[getIndex(index)]" @change="handleCheckItem($event, getIndex(index))"></el-checkbox> -->
            <!-- <el-checkbox
              :disabled="$route.query.class === 'detail'"
              v-model="checkedIndexList[getIndex(index)]"
            ></el-checkbox> -->
            <el-checkbox
              :disabled="$route.query.class === 'detail'"
              v-model="mixinDisplayList[getIndex(index)].checked"
            ></el-checkbox>
          </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="pageInfo.currentPage"
          :page-size="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="mixinDisplayList.length"
        >
        </el-pagination>
      </div>
    </div>

    <div v-else style="text-align:center">
      您暂未配置组合陈列套餐
    </div>

    <!-- 堆箱信息弹窗 -->
    <MixingStackConfigDialog
      ref="mixingStackConfigDialog"
      :brandList="customBrandList"
      :dialogVisible="stackDialogVisible"
      @addStackInfo="addStackInfo"
      @closeStackDialog="closeStackDialog"
    >
    </MixingStackConfigDialog>

    <!-- 产品信息弹窗 -->
    <ProductConfigDialog
      ref="productConfigDialog"
      :brandList="customBrandList"
      :specList="specList"
      :sizeList="sizeList"
      :dialogVisible="productDialogVisible"
      @addProductInfo="addProductInfo"
      @closeProductDialog="closeProductDialog"
    >
    </ProductConfigDialog>

    <!-- 混堆设计图弹窗 -->
    <el-dialog
      :title="`${row} * ${column}`"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="designDialogVisible"
      destroy-on-close
      center
      append-to-body
      width="550px"
    >
      <StackDesignConfig
        ref="StackDesignConfig"
        :row="row"
        :column="column"
        :brandSelected="brandSelected"
        disabled
        @handleCancelDesign="designDialogVisible = false"
      ></StackDesignConfig>
    </el-dialog>
  </div>
</template>

<script>
import MixingStackConfigDialog from './mixing-stack-config-dialog'
import ProductConfigDialog from './product-config-dialog'
import StackDesignConfig from './stack-design-config.vue'
import _ from 'lodash'
import { mapState } from 'vuex'
import { commonUtils } from '../../../utils/common'
export default {
  name: 'perfect-theme-config-mixing',
  components: {
    MixingStackConfigDialog,
    ProductConfigDialog,
    StackDesignConfig
  },
  props: {
    employeeLevel: {
      type: Number
    },
    originInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    matchInfo: {
      type: Array,
      default: () => {
        return []
      }
    },
    regionListByBu: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedOrgCode: {
      type: String,
      default: ''
    },
    customBrandList: {
      type: Array,
      default: () => {
        return []
      }
    },
    componentName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 默认数据结构
      defaultData: {
        defineType: '04', // 定义类型，01-堆箱 03-必备品 04-组合陈列
        stackType: '', // 堆箱类型 01-单堆 02-混堆
        defineName: '', // 定义名称
        stackPackBrands: '', // 堆箱品牌
        stackPackSubBrands: '', // 堆箱子品牌
        stackPackSize: '', // 堆箱规格
        regionCodes: '', // 适用区域codes
        regionList: [], // 适用区域codes数组
        brandList: [],
        checked: false,
        checkAll: false,
        tradePerfectScopeDetailList: [
          {
            brandCode: '', // 品牌编码
            subBrandCode: '', // 子品牌编码
            multiPackFlag: '', // 是否多联包
            multiPackSpec: '', // 多联包规格
            minDisplayQty: '', // 最小陈列件
            volume: '', // 容量
            rowQty: null // 排面数
          }
        ]
      },

      mixinDisplayList: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 5
      },
      indexSelected: 0,
      checkedIndexList: [],
      checkedResult: true, // 生成套餐时 数据校验结果

      showStackConfigDialog: false,
      stackDialogVisible: false,
      productDialogVisible: false,

      designDialogVisible: false,
      row: '',
      column: '',
      brandSelected: []
    }
  },
  watch: {
    'selectedOrgCode' () {
      this.filterDataByRegion()
    }
  },
  computed: {
    ...mapState({
      specList: state => state.base.tradePerfectMandatorySpecsMap,
      sizeList: state => state.base.tradePerfectScopeDetailSpecMap
    }),
    // 数据分页
    mixinDisplayListPagination () {
      const startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      const endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      console.log(this.mixinDisplayList.slice(startIndex, endIndex))
      return this.mixinDisplayList.slice(startIndex, endIndex)
    },
    isDetailPage () {
      return this.$route.query.class === 'detail'
    }
  },
  methods: {
    // 对于 bu 来说，config 时组合陈列套餐数据为空；update 时，用 matchInfo 中的数据（即最近一次BU配置的数据），作为默认展示的数据。
    // 对于 region 来说， originInfo 是原始数据（即上级bu配置的数据）用于展示，matchInfo 用于匹配 region 曾经勾选的选项。
    setData () {
      let handleType = this.$route.query.handleType
      // bu update
      if (this.employeeLevel > 50 && handleType === 'update') {
        this.mixinDisplayList = _.cloneDeep(this.matchInfo)
        this.mixinDisplayList.forEach(item => {
          this.$set(item, 'checkAll', false)
        })
      }
      // region
      if (this.employeeLevel <= 50) {
        this.mixinDisplayList = _.cloneDeep(this.originInfo)
        // region update时，需要用 matchInfo 匹配 originInfo 设置上次 region 勾选的选项
        if (handleType === 'update') {
          this.setDefalutSelected()
        }
      }
      // 将后台返回的数据格式化为页面需要的形式
      this.mixinDisplayList.map((item, index) => {
        let formatedObj = this.formatData(item)
        let obj = Object.assign({}, item, formatedObj)
        this.mixinDisplayList.splice(index, 1, obj)
      })
      this.filterDataByRegion()
    },
    // 将数据格式化为页面需要的形式
    formatData (item) {
      let obj = {}
      let stackObj = this.formatStackData(item)
      let productList = this.formatProductData(item.tradePerfectScopeDetailList)
      obj = Object.assign({}, stackObj)
      obj.tradePerfectScopeDetailList = productList
      return obj
    },
    // 匹配上次配置时 region 勾选的选项
    setDefalutSelected () {
      this.mixinDisplayList.forEach(item => {
        this.$set(item, 'checked', false)
        this.matchInfo.forEach(subItem => {
          if (item.scopeDefineId === subItem.scopeDefineId) {
            item.checked = true
          }
        })
      })
    },
    // 处理 RTM 跨region时，根据所选区域判断filter需要展示的数据
    filterDataByRegion () {
      if (this.employeeLevel <= 50 && this.$route.query.handleType === 'config') {
        if (!this.selectedOrgCode) {
          this.mixinDisplayList = []
          return
        }
        this.mixinDisplayList = this.originInfo.filter((stack) => {
          return stack.regionCodes.indexOf(this.selectedOrgCode) > -1
        })
      }
    },
    // 输入框输入数据格式化
    // checkInput (e, index, type) {
    //   let value = e.replace(/[^\d]/g, '')
    //   let item = this.mixinDisplayListPagination[index]
    //   item[type] = value
    // },
    // 获取分页后 元素在数组中的实际index
    getIndex (index) {
      return (this.pageInfo.currentPage - 1) * this.pageInfo.pageSize + index
    },

    // 新增一行组合陈列套餐
    handleAddRow () {
      if (!this.checkName()) {
        return
      }
      const defaultData = commonUtils.deepClone(this.defaultData)
      let data = Object.assign({},
        defaultData,
        {
          defineName: '组合套餐' + (this.mixinDisplayList.length + 1),
          canUpdate: true
        }
      )
      this.mixinDisplayList.unshift(data)
    },
    // 删除一行组合陈列套餐
    handleDeleteRow (index) {
      this.$confirm('是否确认删除该套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.mixinDisplayList.splice(index, 1)
        })
        .catch(() => {})
    },

    // 获取当前数据行/列数据
    getLine (type, index) {
      const sizeInfo = this.mixinDisplayList[index].stackPackSize
        ? this.mixinDisplayList[index].stackPackSize.split('*')
        : []
      if (type === 'row') {
        return Number(sizeInfo[0])
      }
      if (type === 'column') {
        return Number(sizeInfo[1])
      }
    },
    // 显示堆箱信息弹窗
    showStackInfoDialog (index) {
      if (!this.checkName()) {
        return
      }
      this.indexSelected = index
      this.stackDialogVisible = true
      // this.setStackDefaultData()
    },
    // 关闭堆箱信息弹窗
    closeStackDialog () {
      // this.$refs['mixingStackConfigDialog'].resetData()
      this.stackDialogVisible = false
    },
    // 添加堆箱信息
    addStackInfo (stackData) {
      // console.log('addStackInfo', stackData)
      // // 校验是否有重复数据（堆箱信息与产品信息都相同，才算作重复）
      // let checkResult = this.checkSameInfo({ stackData })
      // if (checkResult) {
      //   this.confirmSetStackData(stackData)
      // }
      this.confirmSetStackData(stackData)
    },
    // 修改堆箱信息
    modifyStackInfo (index) {
      if (!this.checkName()) {
        return
      }
      this.showStackInfoDialog(index)
      this.setStackDefaultData()
    },
    // 设置默认堆箱信息数据
    setStackDefaultData () {
      let item = this.mixinDisplayList[this.indexSelected]
      let obj = this.formatStackData(item)
      // this.$refs['mixingStackConfigDialog'] = obj
      let refs = this.$refs.mixingStackConfigDialog
      refs.stackType = obj.stackType
      refs.row = obj.row
      refs.column = obj.column
      refs.brandCode = obj.brandCode
      refs.subBrandCode = obj.subBrandCode
      refs.brandSelectedMixing = obj.brandSelectedMixing
    },

    // 将堆箱数据格式化为页面需要的形式
    formatStackData (item) {
      let size = item.stackPackSize ? item.stackPackSize.split('*') : []
      let obj = {
        stackType: item.stackType || '01',
        row: item.row || size[0] || '',
        column: item.column || size[1] || '',
        brandCode: item.brandCode || '',
        subBrandCode: item.subBrandCode || '',
        brandSelectedMixing: [],
        regionList: item.regionCodes.split(',') || []
      }
      // 单堆
      if (obj.stackType === '01') {
        obj.brandName = item.subBrandInfo ? item.subBrandInfo.parentBrandName : item.brandName
        obj.brandCode = item.subBrandInfo ? item.subBrandInfo.parentBrandCode : item.brandCode
        obj.subBrandName = item.subBrandInfo ? item.subBrandInfo.abiBrandDesc : item.subBrandName
        obj.subBrandCode = item.subBrandInfo ? item.subBrandInfo.abiBrandCode : item.subBrandCode
      }
      // 混堆
      if (obj.stackType === '02') {
        item.brandList.forEach(item => {
          obj.brandSelectedMixing.push(`${item.abiBrandCode},${item.abiBrandDesc},${item.tradeStackColor}`)
        })
      }
      console.log('formatData', obj)
      return obj
    },
    // set堆箱数据
    confirmSetStackData (stackData) {
      console.log('confirmSetStackData', stackData)
      let rItem = this.mixinDisplayList[this.indexSelected]
      rItem.stackPackSize = `${stackData.row}*${stackData.column}`
      rItem.stackType = stackData.stackType
      rItem.column = stackData.column
      rItem.row = stackData.row
      rItem.brandCode = stackData.brandCode
      rItem.brandName = stackData.brandName
      rItem.subBrandCode = stackData.subBrandCode
      rItem.subBrandName = stackData.subBrandName
      rItem.brandList = []
      let brandList = stackData.brandList || []
      if (brandList.length) {
        brandList.forEach(item => {
          let brandInfo = item ? item.split(',') : []
          rItem.brandList.push({
            abiBrandCode: brandInfo[0],
            abiBrandDesc: brandInfo[1],
            tradeStackColor: brandInfo[2] || ''
          })
        })
      }
      this.mixinDisplayList.splice(this.indexSelected, 1, rItem)
      this.closeStackDialog()
    },

    // 显示产品信息弹窗
    showProductInfoDialog (index) {
      // 校验是否有重复的套餐名称
      if (!this.checkName()) {
        return
      }
      this.indexSelected = index
      console.log('showProductInfoDialog')
      this.productDialogVisible = true
    },
    // 关闭产品信息弹窗
    closeProductDialog () {
      this.$refs.productConfigDialog.resetData()
      this.productDialogVisible = false
    },
    // 添加产品信息
    addProductInfo (productData) {
      this.confirmSetProductData(productData)
    },
    // 修改产品信息
    modifyProductInfo (index) {
      console.log('modifyProductInfo', index)
      this.showProductInfoDialog(index)
      this.setProductDefaultData()
    },
    // 设置默认产品信息数据
    setProductDefaultData () {
      let arr = this.formatProductData(this.mixinDisplayList[this.indexSelected].tradePerfectScopeDetailList)
      this.$nextTick(() => {
        this.$refs.productConfigDialog.productList = _.cloneDeep(arr)
      })
    },
    // 格式化产品信息数据
    formatProductData (arr) {
      arr.forEach(item => {
        item.brandInfo = `${item.brandCode},${item.brandName}`
        item.subBrandInfo = `${item.subBrandCode},${item.subBrandName}`
      })
      return arr
    },
    // 通过校验后 将产品信息set进当前页面数组
    confirmSetProductData (productData) {
      this.mixinDisplayList[this.indexSelected].tradePerfectScopeDetailList = productData.slice(0)
      this.closeProductDialog()
    },
    // 重置
    resetDesign () {
      this.indexSelected = this.$options.data().indexSelected
      this.brandSelected = this.$options.data().brandSelected
    },

    // 查看设计图详情
    viewDesignDetail (index) {
      this.brandSelected = []
      this.indexSelected = this.getIndex(index)
      let rItem = this.mixinDisplayList[this.indexSelected]
      this.row = rItem.stackPackSize.split('*')[0]
      this.column = rItem.stackPackSize.split('*')[1]
      rItem.brandList.forEach(item => {
        this.brandSelected.push(`${item.abiBrandCode},${item.abiBrandDesc},${item.tradeStackColor}`)
      })
      this.designDialogVisible = true
      // this.showDesignCard = true
    },

    // 重置，bu config：直接将数据置为空，bu update：将数据置为上次BU配置的数据，也就是 matchInfo
    // region config：将数据置为 originInfo, region update：将数据置为 originInfo，再利用 matchInfo 设置选中项
    handleReset () {
      console.log('handleReset')
      let handleType = this.$route.query.handleType
      // bu config
      if (this.employeeLevel > 50 && handleType === 'config') {
        this.mixinDisplayList = this.$options.data().mixinDisplayList
      }
      // bu update
      if (this.employeeLevel > 50 && handleType === 'update') {
        this.mixinDisplayList = _.cloneDeep(this.matchInfo)
      }
      // region config
      if (this.employeeLevel <= 50 && handleType === 'config') {
        this.mixinDisplayList = _.cloneDeep(this.originInfo)
        this.setDefalutSelected()
      }
      // region update
      if (this.employeeLevel <= 50 && handleType === 'update') {
        this.setDefalutSelected()
      }
      this.mixinDisplayList.forEach((item, index) => {
        let formatedObj = this.formatData(item)
        let obj = Object.assign({}, item, formatedObj)
        this.mixinDisplayList.splice(index, 1, obj)
      })
      this.filterDataByRegion()
    },

    // 检查套餐名称是否重复
    checkName (e) {
      if (e && !e.target.value) {
        this.$message.warning('组合陈列套餐名称不能为空')
        return
      }
      let hasSameName = false
      // let defineNameDuplicate
      for (let j = 0; j < this.mixinDisplayList.length; j++) {
        for (let i = (j + 1); i < this.mixinDisplayList.length; i++) {
          if (this.mixinDisplayList[j].defineName === this.mixinDisplayList[i].defineName) {
            hasSameName = true
            // defineNameDuplicate = this.mixinDisplayList[j].defineName
            break
          }
        }
      }
      // 名称未重复则checkResult为true
      let checkResult = !hasSameName
      if (!checkResult) {
        this.$message.warning('组合陈列套餐名称重复')
      }
      return checkResult
    },

    checkData () {
      this.checkedResult = true

      // bu校验 每个套餐内容都不会为空 则通过校验
      if (this.employeeLevel > 50) {
        // 校验混堆名字重复
        this.checkedResult = this.checkName()

        // 需要有组合陈列套餐
        if (this.mixinDisplayList.length === 0) this.checkedResult = false

        // 每个套餐内容都不会为空
        if (this.mixinDisplayList.length) {
          this.mixinDisplayList.forEach(item => {
            if (
              !item.stackPackSize ||
              !item.tradePerfectScopeDetailList[0] ||
              !item.tradePerfectScopeDetailList[0].brandCode
            ) {
              this.checkedResult = false
            }
          })
        }
      }

      // region校验 当有 >= 1个勾选时 则通过校验
      if (this.employeeLevel <= 50) {
        let checkedResult = false
        if (this.mixinDisplayList.length) {
          this.mixinDisplayList.forEach(item => {
            if (item.checked) checkedResult = true
          })
        }
        this.checkedResult = checkedResult
      }

      // if (!checkedResult) this.$parent.checkedResult = checkedResult
    },

    // 全选/取消全选
    handleCheckAllChange (e, item) {
      if (e) {
        this.regionListByBu.forEach(list => {
          item.regionList.push(list.orgCode)
        })
      } else {
        item.regionList = []
      }
    },

    handleRegionChange (e, item) {
      item.checkAll = this.regionListByBu.every(item => {
        return e.indexOf(item.orgCode) !== -1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.require {
  color: red;
}
.wrapper {
  position: relative;
  // padding: 10px 30px;
  // border-radius: 10px;
  background-color: #fff;
  // height: 800px;
  .content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .title {
      display: flex;
      flex: none;
      width: 100%;
      // flex-basis: 14%;
      font-size: 16px;
      font-weight: 600;
      justify-content: space-between;
      div {
        // width: 100%;
        text-align: right;
      }
      .el-button {
        display: inline-block;
      }
    }
  }
  .info {
    position: relative;
    // min-height: 700px;
    .header {
      line-height: 40px;
      border-radius: 5px;
      background: #eee;
    }
    .el-col {
      text-align: center;
    }
    .detail {
      min-height: 120px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 10px;
      .design-thumbnail {
        display: flex;
        justify-content: center;
        overflow-x: auto;
        width: 100%;
        height: 100%;
        cursor: pointer;
        .design-thumbnail-column {
          display: inline-block;
        }
        .design-thumbnail-row {
          box-sizing: border-box;
          width: 25px;
          height: 25px;
          border: 1px solid #c0c4cc;
          border-radius: 3px;
        }
      }
      .stack-design-modify {
        cursor: pointer;
        color: red;
      }
      .design {
        text-align: center;
        .design-img {
          display: flex;
          flex-wrap: wrap;
          height: 100px;
          width: 100px;
          margin: 0 auto;
          // border: 1px solid #C0C4CC;
          border-radius: 8px;
          div {
            box-sizing: border-box;
            display: inline-block;
            border: 1px solid #c0c4cc;
            border-radius: 3px;
          }
        }
      }
      .region-wrapper {
        line-height:30px;
        text-align:left;
        padding: 10px 0;
      }
      .product-info {
        line-height: 20px;
        padding: 5px 10px;
      }
    }
  }
  .card-wraper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
  .box-card {
    // width: 700px;
    pointer-events: auto;
    z-index: 2;
    .card-header {
      text-align: center;
      line-height: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      span {
        display: inline-block;
        width: 50%;
      }
    }
    .card-select {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      max-height: 500px;
      padding-bottom: 20px;
      min-width: 350px;
    }
    .card-box{
      margin:auto;
    }
  }
  .card-item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100px;
    height: 80px;
    margin: 10px auto 0;
    line-height: initial;
    text-align: center;
    color: #fff;
    border: 1px solid #c0c4cc;
    border-radius: 10px;
  }
  .card-operte {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }
  .pagination {
    text-align: center;
    padding: 20px 0;
  }
}
.el-select {
  width: 120px;
}
</style>
